<template>
  <div style="padding: 0px;">
    <challenge-listing
      :title="title"
      :challenges="challengesNotEmpty"
      :archivePage="false"
      :dropdownOptions="options"
      :challengesLoaded="challengesLoaded"
      :pageInfos.sync="pageInfos"
      @action="action($event.challenge, $event.id)"
      @newPage="getPageOfChallengesForOrg($event.pageNum, $event.pageSize, $event.orgId)"/>
    <v-btn
      id="add-challenge-button"
      color="rgb(255, 149, 24)"
      dark
      fixed
      bottom
      right
      fab
      x-large
      link
      style="bottom: 1em;"
      @click="addNewChallenge()"
      v-if="canAddChallenges"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <DeleteChallengeDialog
      :visible.sync="deleteModalVisible"
      :challenge="challengeToDelete"
      @confirm="deleteChallenge"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ChallengeListing from '@/components/challenge/challengeList/ChallengeListing.vue'
import DeleteChallengeDialog from '@/components/challenge/DeleteChallengeModal.vue'

export default {
  name: 'ChallengeList',

  props: ['global'],

  components: {
    ChallengeListing,
    DeleteChallengeDialog
  },

  data: () => ({
    challengesLoaded: false,
    deleteModalVisible: false,
    challengeToDelete: null,
    pageInfos: {},
    options: [
      { text: 'Archive', icon: 'mdi-package-down', anyoneCanAccess: false, id: 'archive' },
      { text: 'Edit', icon: 'mdi-pencil', anyoneCanAccess: false, id: 'edit' },
      { text: 'Delete', icon: 'mdi-delete', anyoneCanAccess: false, id: 'delete' }
    ]
  }),

  computed: {
    ...mapState({
      challenges: state => state.challenge.activeChallengesByOrg,
      userInfo: state => state.auth.userInfo,
      organizations: state => state.organization.organizations
    }),

    challengesNotEmpty () {
      if (this.global) {
        return this.challenges.filter(c => c.challenges.length > 0)
      }
      return this.challenges
    },

    title () {
      if (this.global) {
        return 'Global Active Challenges'
      } else {
        return 'Active Challenges'
      }
    },

    canAddChallenges () {
      // at least one organization is not org standard OR is system admin
      return this.userInfo.organizations.some(o => o.scope !== 'org_standard') || this.userInfo.account.systemAdmin
    },

    organizationsWithChallenges () {
      if (this.global) {
        return this.organizations.filter(o => o.challenges > 0)
      }
      return []
    }
  },

  watch: {
    global: {
      immediate: true,
      async handler () {
        this.challengesLoaded = false
        await this.getPageOfChallenges(1, 5)
        this.challengesLoaded = true
      }
    }
  },

  methods: {
    ...mapActions([
      'requestActiveChallenges',
      'requestArchiveChallenge',
      'requestActiveChallengesByOrg',
      'requestDeleteChallenge'
    ]),

    async getPageOfChallenges (pageNum, pageSize) {
      this.pageInfos = await this.requestActiveChallenges({
        pageNum: pageNum,
        pageSize: pageSize,
        fetchGlobal: this.organizationsWithChallenges
      })
    },

    async getPageOfChallengesForOrg (pageNum, pageSize, orgId) {
      this.pageInfos[orgId] = await this.requestActiveChallengesByOrg({
        pageNum: pageNum,
        pageSize: pageSize,
        orgId: orgId,
        global: this.global
      })
    },

    async action (challenge, eventId) {
      switch (eventId) {
        case 'archive':
          this.handleOperation(this.requestArchiveChallenge, challenge, 'Failed to archive challenge')
          break
        case 'edit':
          this.$router.push(`/admin-dashboard/challenge/${challenge.uuid}`)
          break
        case 'delete':
          this.challengeToDelete = challenge
          this.deleteModalVisible = true
          break
      }
    },

    deleteChallenge (challenge) {
      this.handleOperation(this.requestDeleteChallenge, challenge, 'Failed to delete challenge')
    },

    async handleOperation (operation, challenge, failMessage) {
      // do the operation
      const success = await operation(challenge)
      if (!success) {
        alert(failMessage)
      }

      // refresh the list
      let pageInfos = {}
      pageInfos = this.pageInfos[challenge.organization]
      this.getPageOfChallengesForOrg(pageInfos.pageNum, pageInfos.pageSize, challenge.organization)
    },

    addNewChallenge () {
      this.$router.push({ name: 'new-challenge' })
    }
  }
}
</script>
